import { createAction, props } from '@ngrx/store';
import { FormState } from './formFormation.reducer';

export const loadForm = createAction('[FormFormation] Load FormFormation');

export const saveForm = createAction('[FormFormation] Save FormFormation');

export const updateForm = createAction(
    '[Form] Update FormFormation',
    props<FormState>()
);

